import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import Pagination from '../layouts/pagination.jsx';
// import DeleteComponent from '../../action/delete.jsx';
import UpdateStatusComponent from '../../action/updatestatus.jsx';
// import EditMeter from './sections/edit';

const InactiveMeter = () => {
    const [meters, setMeters] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    // const [meterId, setMeterId] = useState(null);
    const [filterText, setFilterText] = useState('');

    const fetchMeters = async (currentPage) => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/meter?meter=inactive&page=${currentPage + 1}`)
            .then(response => {
                setMeters(response.data.data);
                setPageCount(Math.ceil(response.data.meta.pagination.total / response.data.meta.pagination.per_page));
            })
            .catch(error => {
                console.error("Error fetching meters!", error);
                setMeters([]);
            });
    };

    useEffect(() => {
        fetchMeters(currentPage);
    }, [currentPage]);
    
    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    // Search input handler
    const filteredItems = meters.filter((item) => {
        const matchesName = item.name.toLowerCase().includes(filterText.toLowerCase());
        return matchesName;
    });

    return (
        <>    
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center timeLog">
                        <div className="col">
                            <h3 className="page-title">Inactive Meter</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Inactive Meter</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4 mb-3">
                        <input className="form-control" type="text"
                            placeholder="Search meter..." aria-label="Search Input"
                            value={filterText} onChange={(event)=>{
                                setFilterText(event.target.value)
                            }} />
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table table-striped custom-table">
                                        <thead>
                                            <tr>
                                                <th>Meter Name</th>
                                                <th>Upwork Name</th>
                                                <th>Status</th>
                                                {/* <th className="text-end">Action</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                filteredItems.length > 0 ? (
                                                    filteredItems.map((meter) => (
                                                        <tr key={meter.id}>
                                                            <td>{meter.name}</td>
                                                            <td>{meter.upwork_name}</td>
                                                            <td>
                                                                <UpdateStatusComponent 
                                                                    url = "meter/status"
                                                                    id = {meter.id}
                                                                    fetchData={fetchMeters} 
                                                                    status={meter.status}
                                                                    />                                                                
                                                            </td>
                                                            {/* <td className="text-end">
                                                                <div className="dropdown dropdown-action">
                                                                    <Link to="#" className="action-icon dropdown-toggle"
                                                                        data-bs-toggle="dropdown" aria-expanded="false"
                                                                            onClick={() => setMeterId(`${meter.id}`)}>
                                                                            <i className="material-icons">more_vert</i></Link>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <Link className="dropdown-item" to="#" data-bs-toggle="modal"
                                                                            data-bs-target={`#edit_meter_${meter.id}`}>
                                                                                <i className="fa-solid fa-pencil m-r-5"></i> Edit</Link>
                                                                            <DeleteComponent 
                                                                                url = "meter"
                                                                                id = {meter.id}
                                                                                fetchData={fetchMeters} />
                                                                    </div>
                                                                </div>
                                                            </td> */}
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="3">No records found</td>
                                                    </tr>
                                                )                                          
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Pagination pageCount={pageCount} handlePageClick={handlePageClick}/>
            </div>

            {/* <EditMeter list={fetchMeters} meterId={meterId} /> */}
        </>
    );
}

export default InactiveMeter